import { render } from "./DesignDropbox.vue?vue&type=template&id=eb50a4ee&scoped=true"
import script from "./DesignDropbox.vue?vue&type=script&lang=js"
export * from "./DesignDropbox.vue?vue&type=script&lang=js"

import "./DesignDropbox.vue?vue&type=style&index=0&id=eb50a4ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb50a4ee"]])

export default __exports__